import { Component, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services';

@Component({
  selector: 'ui-loader-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './loader-bar.component.html',
  styleUrls: ['./loader-bar.component.scss']
})
export class LoaderBarComponent {

  constructor(
    private loaderService: LoaderService
  ) { }

  get show(): Observable<boolean> {
    return this.loaderService.getLoader().
      pipe(
        map(loaderState => loaderState ? loaderState.show : false)
      );
  }

  get message(): Observable<string | null> {
    return this.loaderService.getLoader().
      pipe(
        map(loaderState => loaderState ? loaderState.message : null)
      );
  }

  // get sidebarShow(): Observable<boolean> {
  //   return this.currentSessionStore.sidebarShow;
  // }


}
